export default __webpack_public_path__ + "static/4-article-b650af731ad251ab5e48ede324e2f265.jpg";